"use server";

import type { PublicKeyCredentialRequestOptionsJSON } from "@simplewebauthn/server";

import {
  passkeyLogin,
  passkeyLoginOptions,
  runLoginStep,
  type LoginState,
} from "@/lib/auth/login-steps";

// The CLIENT login page's steps. The logic lives in lib/auth/login-steps.ts,
// shared with the staff sign-in (app/staff/login/actions.ts); these wrappers
// pin the account kind, so this endpoint can only ever sign a client in.

export type { LoginState, LoginStep } from "@/lib/auth/login-steps";

export async function loginAction(_prev: LoginState, formData: FormData): Promise<LoginState> {
  return runLoginStep("client", formData);
}

export async function passkeyOptionsAction(): Promise<PublicKeyCredentialRequestOptionsJSON | null> {
  return passkeyLoginOptions("client");
}

export async function passkeyLoginAction(
  responseJSON: string,
  callbackUrl: string,
): Promise<{ error: string }> {
  return passkeyLogin("client", responseJSON, callbackUrl);
}
